module.exports = __webpack_public_path__ + "static/media/chevron_up.a2f49d60.svg";